import React from 'react';
export var StepsSlideContext = /*#__PURE__*/React.createContext({
  isActive: false,
  index: 0
});